var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "languages",
      class: _vm.languageDropdown ? "opened" : "closed",
    },
    [
      _c(
        "span",
        {
          on: {
            click: function ($event) {
              $event.stopPropagation()
              return _vm.toggleDropdownMenu("lang")
            },
          },
        },
        [
          _c(
            "div",
            { staticClass: "language-hover d-flex align-items-center" },
            [
              _c("i", { class: "icon language-" + _vm.locale + " mr-2" }),
              _c("span", { staticClass: "lang" }, [
                _vm._v(_vm._s(_vm.languages[_vm.locale])),
              ]),
            ]
          ),
        ]
      ),
      _vm.languageDropdown
        ? _c(
            "div",
            {
              staticClass: "dropdown-menu d-block",
              on: {
                mouseleave: function ($event) {
                  return _vm.closeDropdownMenu()
                },
              },
            },
            _vm._l(_vm.languages, function (l, k) {
              return _c(
                "a",
                {
                  key: k,
                  staticClass: "dropdown-item",
                  class: "icon language-" + k,
                  attrs: { href: "#", class: { active: k == _vm.locale } },
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      return _vm.setLang(k)
                    },
                  },
                },
                [_vm._v(_vm._s(l))]
              )
            }),
            0
          )
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }